import { render } from "./About.vue?vue&type=template&id=312e8a72"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render

export default script